import {createContract} from "../index";

export const OPENSEA_CONTRACT_ADDRESS = process.env.VUE_APP_OPENSEA_STORE;
const ABI = require("./opensea.abi.json");

export const createOpenSeaContract = function(web3) {
  return createContract(OPENSEA_CONTRACT_ADDRESS, ABI, web3);
}
